import React from "react";
import { Box } from "@mui/material";
import { FN } from "./facilityNetworkTheme";

type Props = {
  children: React.ReactNode;
};

/** Fills dashboard pane. One vertical scroller — do not nest overflow-y auto above this. */
export default function FacilityNetworkPageShell({ children }: Props) {
  return (
    <Box
      sx={{
        bgcolor: FN.pageBg,
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        maxWidth: "100%",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "12px",
        border: `1px solid ${FN.shellBorder}`,
        boxShadow: FN.shellInsetShadow,
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        pt: FN.shellPaddingTop,
        pl: FN.shellPaddingLeft,
        pr: FN.shellPaddingRight,
        pb: FN.shellPaddingRight,
      }}
    >
      {children}
    </Box>
  );
}
